// Step 2: Atlas-side endpoint service creation
export const getAtlasEndpointServiceTerraformCode = (params: {
  atlasProjectId: string;
  region: string;
}): string => {
  const { atlasProjectId, region } = params;

  return `\
# Configure the MongoDB Atlas provider authentication.
# See: https://registry.terraform.io/providers/mongodb/mongodbatlas/latest/docs/guides/provider-configuration#authentication-methods

provider "mongodbatlas" {
    public_key  = "<your-atlas-public-key>"
    private_key = "<your-atlas-private-key>"
}

resource "mongodbatlas_privatelink_endpoint" "eon" {
    project_id    = "${atlasProjectId || '<atlas-project-id>'}"
    provider_name = "AWS"
    region        = "${region || '<aws-region>'}"
}

# After applying, note the endpoint_service_id output value:
#   terraform output -raw mongodbatlas_privatelink_endpoint.eon.endpoint_service_id
# You will need it to create the VPC endpoint in your AWS account (Step 3).`;
};

export const getAtlasEndpointServiceBashCode = (params: {
  atlasProjectId: string;
  region: string;
}): string => {
  const { atlasProjectId, region } = params;

  return `\
# Create the Atlas PrivateLink endpoint service using the Atlas Admin API.
# Replace <public-key> and <private-key> with your Atlas API credentials.

curl --user "<public-key>:<private-key>" --digest \\
  --header "Content-Type: application/json" \\
  --request POST \\
  --data '{
    "providerName": "AWS",
    "region": "${region || '<aws-region>'}"
  }' \\
  "https://cloud.mongodb.com/api/atlas/v1.0/groups/${atlasProjectId || '<atlas-project-id>'}/privateEndpoint/endpointService"

# Note the "id" field in the response — this is the endpoint_service_id.
# You will need it to create the VPC endpoint in your AWS account (Step 3).`;
};

// Step 2: Register VPC endpoint with Atlas (extends Step 1 Terraform)
export const getAtlasRegisterEndpointTerraformCode = (params: {
  atlasProjectId: string;
  region: string;
  vpcEndpointId: string;
}): string => {
  const { atlasProjectId, region, vpcEndpointId } = params;

  return `\
# Configure the MongoDB Atlas provider authentication.
# See: https://registry.terraform.io/providers/mongodb/mongodbatlas/latest/docs/guides/provider-configuration#authentication-methods

provider "mongodbatlas" {
    public_key  = "<your-atlas-public-key>"
    private_key = "<your-atlas-private-key>"
}

# Step 1: Create the Atlas PrivateLink endpoint service
resource "mongodbatlas_privatelink_endpoint" "eon" {
    project_id    = "${atlasProjectId || '<atlas-project-id>'}"
    provider_name = "AWS"
    region        = "${region || '<aws-region>'}"
}

# Step 2: Register the Eon VPC endpoint with Atlas
resource "mongodbatlas_privatelink_endpoint_service" "eon" {
    project_id          = "${atlasProjectId || '<atlas-project-id>'}"
    private_link_id     = mongodbatlas_privatelink_endpoint.eon.id
    endpoint_service_id = "${vpcEndpointId || '<vpc-endpoint-id>'}"
    provider_name       = "AWS"
}`;
};

export const getAtlasRegisterEndpointBashCode = (params: {
  atlasProjectId: string;
  region: string;
  vpcEndpointId: string;
}): string => {
  const { atlasProjectId, region, vpcEndpointId } = params;

  return `\
# Register the VPC endpoint with Atlas using the Atlas Admin API.
# Replace <public-key> and <private-key> with your Atlas API credentials.

ATLAS_PUBLIC_KEY="<public-key>"
ATLAS_PRIVATE_KEY="<private-key>"
PROJECT_ID="${atlasProjectId || '<atlas-project-id>'}"
VPC_ENDPOINT_ID="${vpcEndpointId || '<vpc-endpoint-id>'}"

# Step 1: Find the endpoint service ID for region ${region || '<aws-region>'}
ENDPOINT_SERVICE_ID=$(curl -s --user "$ATLAS_PUBLIC_KEY:$ATLAS_PRIVATE_KEY" --digest \\
  "https://cloud.mongodb.com/api/atlas/v1.0/groups/$PROJECT_ID/privateEndpoint/endpointService" \\
  | jq -r '.[] | select(.regionName=="${(region || '<aws-region>').toUpperCase().replace(/-/g, '_')}") | .id')

echo "Found endpoint service ID: $ENDPOINT_SERVICE_ID"

# Step 2: Register the VPC endpoint
curl --user "$ATLAS_PUBLIC_KEY:$ATLAS_PRIVATE_KEY" --digest \\
  --header "Content-Type: application/json" \\
  --request POST \\
  --data '{
    "id": "'"$VPC_ENDPOINT_ID"'"
  }' \\
  "https://cloud.mongodb.com/api/atlas/v1.0/groups/$PROJECT_ID/privateEndpoint/endpointService/$ENDPOINT_SERVICE_ID/endpoint"`;
};
